<template>
  <div id="VisitorsSelectList">
    <VisitorInfo
      v-for="(visitor, key) in visitors"
      :id="`visitor-info-${key}`"
      :visitor="visitor"
      variant="info"
      :key="key"
      :nationality="nationalities.find((item) => item.id === visitor.personal.nationality_id)"
      :identification="identifications.find((item) => item.id === visitor.personal.identification_id)"
    >
      <template v-slot:menu>
        <b-button @click="moveVisitorToWorker(key)">
          <i class="glyphicon glyphicon-menu-right pull-right"></i>
        </b-button>
      </template>
    </VisitorInfo>
  </div>
</template>

<script>
import VisitorInfo from './VisitorInfo'

export default {
  name: 'VisitorsSelectList',
  components: { VisitorInfo },
  props: {
    /**
     * Identification document type
     */
    identifications: {
      type: Array
    },

    /**
     * Flags icons
     */
    nationalities: {
      type: Array
    },

    moveVisitorToWorker: {
      type: Function
    },

    /**
     * Visitors for select
     */
    visitors: {
      type: Array
    }
  }
}
</script>
